// 말소 진행 셀프조회 (수출업체) — 자기 차량 말소 진행상황을 직접 조회 + 실시간 단계 알림.
//   백엔드: GET /cancel-tracking/my, 소켓 cancel:step (단계 전이 시 토스트+갱신)
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';

var NAVY = '#1B3A5C';
// 표시 단계(4) — 진행중은 담당배정에, 보류는 별도 뱃지
var STEPS = [
  { key: '대기', label: '접수대기', icon: '📥' },
  { key: '접수', label: '담당배정', icon: '🙋' },
  { key: '수거완료', label: '번호판 수거완료', icon: '📦' },
  { key: '완료', label: '말소완료', icon: '✅' }
];
function dispIndex(status) {
  if (status === '완료') return 3;
  if (status === '수거완료') return 2;
  if (status === '접수' || status === '진행중' || status === '보류') return 1;
  return 0;
}

function CancelTracking({ user }) {
  var itemsState = useState([]); var items = itemsState[0]; var setItems = itemsState[1];
  var loadingState = useState(true); var loading = loadingState[0]; var setLoading = loadingState[1];

  function load() {
    authFetch(API + '/cancel-tracking/my').then(function (r) { return r.json(); })
      .then(function (d) { setItems(Array.isArray(d) ? d : []); setLoading(false); })
      .catch(function () { setLoading(false); });
  }
  useEffect(function () { load(); }, []);
  useEffect(function () {
    var sock = getSocket(); if (!sock) return;
    // 토스트는 Dashboard 전역 리스너가 담당 → 여기선 목록 실시간 갱신만 (중복 토스트 방지)
    function onStep() { load(); }
    sock.on('cancel:step', onStep);
    return function () { try { sock.off('cancel:step', onStep); } catch (e) {} };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1000, margin: '0 auto' }}>
      <div style={{ fontSize: 22, fontWeight: 800, color: NAVY, marginBottom: 4 }}>{'🚗 말소 진행 조회'}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 20, lineHeight: 1.6 }}>
        {'의뢰하신 차량의 말소 진행 상황입니다. 단계가 바뀌면 자동으로 알려드립니다.'}</div>

      {loading && <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>{'불러오는 중...'}</div>}
      {!loading && items.length === 0 && (
        <div style={{ padding: 50, textAlign: 'center', color: '#94a3b8', background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 32, opacity: 0.4 }}>{'🚗'}</div>
          <div style={{ marginTop: 8 }}>{'진행 중인 말소 건이 없습니다'}</div>
        </div>
      )}
      {!loading && items.map(function (it) {
        var cur = dispIndex(it.status);
        var isHold = it.status === '보류';
        return (
          <div key={it.id} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: '16px 18px', marginBottom: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 16, fontWeight: 800, color: NAVY }}>{it.carNo || '-'}</span>
              <span style={{ fontSize: 12, color: '#64748b' }}>{it.carType || ''}</span>
              <span style={{ fontSize: 11, color: '#475569' }}>{it.cancelType || ''}</span>
              {it.agencyName && <span style={{ fontSize: 11, color: '#1d4ed8', background: '#eff6ff', borderRadius: 10, padding: '2px 8px' }}>{'대행: ' + it.agencyName}</span>}
              {isHold && <span style={{ fontSize: 11, fontWeight: 700, color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, padding: '2px 8px' }}>{'⏸ 보류'}</span>}
            </div>
            {/* 스텝퍼 */}
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              {STEPS.map(function (s, i) {
                var done = i <= cur;
                var isCur = i === cur && !isHold;
                return (
                  <React.Fragment key={s.key}>
                    <div style={{ flex: '0 0 auto', textAlign: 'center', width: 78 }}>
                      <div style={{ width: 36, height: 36, borderRadius: '50%', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
                        background: done ? (i === 3 ? '#16a34a' : NAVY) : '#e2e8f0', color: done ? '#fff' : '#94a3b8',
                        boxShadow: isCur ? '0 0 0 4px rgba(27,58,92,0.15)' : 'none' }}>{s.icon}</div>
                      <div style={{ fontSize: 11, marginTop: 6, fontWeight: isCur ? 800 : 600, color: done ? NAVY : '#94a3b8' }}>{s.label}</div>
                    </div>
                    {i < STEPS.length - 1 && <div style={{ flex: 1, height: 3, background: i < cur ? NAVY : '#e2e8f0', marginTop: 17, borderRadius: 2 }} />}
                  </React.Fragment>
                );
              })}
            </div>
            {/* 일정 */}
            <div style={{ marginTop: 14, fontSize: 11.5, color: '#64748b', display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              {it.requestDate && <span>{'요청일 ' + it.requestDate}</span>}
              {it.acceptedAt && <span>{'접수 ' + it.acceptedAt}</span>}
              {it.eta_at && it.status !== '완료' && <span style={{ color: '#1d4ed8' }}>{'도착예정 ' + it.eta_at}</span>}
              {it.picked_up_at && <span>{'수거 ' + (it.picked_up_at || '').slice(0, 16)}</span>}
              {it.completedDate && <span style={{ color: '#15803d', fontWeight: 700 }}>{'완료 ' + it.completedDate}</span>}
              {isHold && it.hold_reason && <span style={{ color: '#b45309' }}>{'사유: ' + it.hold_reason}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default CancelTracking;
